import { LoanOfferMode } from '@shared/sec-loans'
import { IntlShape } from 'react-intl'

export const getLoanOfferLocalizedEnums = (
  formatMessage: IntlShape['formatMessage'],
): {
  loanOfferModeDescriptionTexts: Record<LoanOfferMode, string>
} => {
  const loanOfferModeDescriptionTexts: Record<LoanOfferMode, string> = {
    [LoanOfferMode.Automatic]: formatMessage({ id: 'loan-offer-status-step-automatic-offer-label' }),
    [LoanOfferMode.Manual]: formatMessage({ id: 'loan-offer-status-step-manual-offer-label' }),
  }

  return { loanOfferModeDescriptionTexts }
}
